module.exports = __webpack_public_path__ + "img/visa.92818530.png";